import React from "react";

// TODO 要render
export default function TehaijokyoFinish() {
  return <></>;
}
